import React, { memo } from "react";
import styles from "./PrivacyPolicyContainer.module.scss";

import { PageWrapper, RecomendedQuests } from "components";

const TermsOfUseContainer = (props: any) => {
  return (
    <>
      <PageWrapper>
        {/* <div className={'flex flex-col items-center sm:flex-shrink-1 pb-4 md:p-2 sm:p-2 min-h-screen'}> */}
        <div
          className={
            "flex flex-wrap flex-col justify-center text-textAr text-left text-base w-full mt-12 sm:px-4 mb-8 sm:mt-5"
          }
        >
          <div className="text-xl text-center sm:text-left font-bold text-pink">
            ПОЛИТИКА ОБЩЕСТВА С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ «ОЛД МАУС» В ОТНОШЕНИИ ОБРАБОТКИ ФАЙЛОВ COOKIE
          </div>

          <br />
          <span className="text-white text-left">1. Куки (англ. cookies) (далее - cookie , файлы cookie) являются текстовым файлом, сохраненным в браузере компьютера (мобильного устройства) пользователя официального интернет-сайта ООО «ОЛД МАУС» - questminsk.by (далее – сайт) при его посещении пользователем для отражения совершенных им действий. Этот файл позволяет не вводить заново или выбирать те же параметры при повторном посещении сайта, например, выбор языковой версии. Целью обработки cookie является обеспечение удобства пользователей сайта и повышение качества его функционирования. Мы не передаем cookie третьим лицам и не используем их для идентификации субъектов персональных данных.</span>
          <br />
          <span className="text-white text-left">2. На сайте обрабатываются следующие типы cookie:</span>
          <br />
          <br />
          <span className="text-pink text-left">
            Обязательные файлы cookie.
          </span>
          <br />
          Обязательные файлы cookie используются ООО «ОЛД МАУС» с целью правильного функционирования сайта и корректного использования предлагаемых на нем возможностей. Отключение данного типа файлов cookie может привести к ограничению доступа пользователя к функциональным возможностям сайта, поэтому данный тип файлов cookie не подлежит отключению.
          <br />
          <br />
          <br />
          <span className="text-pink text-left">Функциональные файлы cookie.</span>
          Функциональные файлы cookie позволяют усовершенствовать взаимодействие пользователя с сайтом, предоставлять пользователю расширенный набор функций и персонализировать контент. Отключение данного типа файлов cookie может привести к ограничению доступа пользователя к функциональным возможностям сайта, некорректной работе некоторых его функций.

          <br />
          <br />
          <br />
          <span className="text-pink text-left">Рекламные файлы cookie.</span>
          <br />
          Рекламные файлы cookie используются для целей маркетинга и улучшения качества рекламы (предоставление более релевантного контента и персонифицированной рекламы на других сайтах), а также помогают улучшить производительность cайта и сделать его более удобным для использования. Эти файлы cookie позволяют узнать количество посещений и анализировать источники трафика, что необходимо для улучшения качества сайта. Рекламные файлы cookie не хранят личную информацию пользователя сайта, а содержат данные онлайн-идентификаторов, сведения о браузере и операционной системе.
          <br />
          <br />
          <br />
          <span className="text-white text-left">3. Устанавливаются следующие сроки хранения файлов cookie:</span>
          <br />
          - Обязательные файлы cookie – не более 1 (одного) года;

          <br />
          - Функциональные файлы cookie – не более суток;

          <br />
          - Рекламные файлы cookie – не более 1 (одного) года.
          <br />
          <br />
          <br />
          <span className="text-white text-left">
            4. Отключение обязательных файлов cookie может привести к ограничению доступа пользователя к функциональным возможностям сайта, поэтому данный тип файлов cookie не подлежит отключению.
          </span>
          <br />
          Корректная работа сайта возможна только в случае использования функциональных файлов cookie, их отключения может привести к ограничению пользователя в доступе к определенным функциональным возможностям сайта.
          <br /> <br />
          Отключение статистических файлов cookie не позволяет определять предпочтения пользователей сайта, в том числе наиболее и наименее популярные страницы и принимать меры по совершенствованию работы сайта исходя из предпочтений пользователей. Запрет использования рекламных файлов cookie приведет к тому, что реклама, которую будет видеть пользователь, будет неперсонализированной (без учета предпочтений пользователя).
        </div>
        {/* </div> */}
      </PageWrapper>
      <RecomendedQuests {...props} />
    </>
  );
};

export default memo(TermsOfUseContainer);
